import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {LayoutComponent} from './base/layout/layout.component';
import {NotFoundComponent} from './not-found/not-found.component';
import {BaseRuLayoutComponent} from './busy-fly-ru/base-ru-layout/base-ru-layout.component';
import {NavigationComponent} from './base/navigation/navigation.component';
import {FooterComponent} from './base/footer/footer.component';
import {MainComponent} from './base/main/main.component';
import {AboutComponent} from './base/about/about.component';
import {RulesComponent} from './base/rules/rules.component';
import {TickerComponent} from './base/ticker/ticker.component';
import {InfoComponent} from './base/info/info.component';
import {InstagramComponent} from './base/instagram/instagram.component';
import {ContactUsComponent} from './base/contact-us/contact-us.component';
import {ScrollToTopBtnComponent} from './base/scroll-to-top-btn/scroll-to-top-btn.component';
import {TariffComponent} from './base/tariff/tariff.component';
import {RentalAgreementComponent} from './rental-agreement/rental-agreement.component';
import {PrivacyPolicyComponent} from './privacy-policy/privacy-policy.component';
import {LicenseAgreementComponent} from './license-agreement/license-agreement.component';
import {RulesOfUseComponent} from './rules-of-use/rules-of-use.component';
import {InsuranceComponent} from './insurance/insurance.component';
import {KzLayoutComponent} from './busy-fly-kz/kz-layout/kz-layout.component';
import {BaseLayoutComponent} from './base/base-layout/base-layout.component';
import {ByLayoutComponent} from './busy-fly-by/by-layout/by-layout.component';
import {ByContactUsComponent} from './busy-fly-by/by-layout/by-contact-us/by-contact-us.component';
import {PartsComponent} from './parts/parts.component';
import {PaymentInformationComponent} from './payment-information/payment-information.component';
import {DocumentsComponent} from './documents/documents.component';
import {DocumentCountriesComponent} from './documents/document-countries/document-countries.component';
import {MousemoveDirective} from './mousemove.directive';
import {KgLayoutComponent} from './busy-fly-kg/by-layout/kg-layout.component';
import {RequisitesComponent} from './base/requisites/requisites.component';
import {RuLayoutComponent} from './busy-fly-ru/ru-layout/ru-layout.component';
import {RequisitesRuComponent} from './busy-fly-ru/requisites-ru/requisites-ru.component';
import {DrivingRulesComponent} from './driving-rules/driving-rules.component';
import { HowToRideComponent } from './how-to-ride/how-to-ride.component';
import { PublicOfferCourierComponent } from './public-offer-courier/public-offer-courier.component';

@NgModule({
  declarations: [
    AppComponent,
    LayoutComponent,
    NotFoundComponent,
    BaseRuLayoutComponent,
    NavigationComponent,
    FooterComponent,
    MainComponent,
    AboutComponent,
    RulesComponent,
    TickerComponent,
    InfoComponent,
    InstagramComponent,
    ContactUsComponent,
    ScrollToTopBtnComponent,
    TariffComponent,
    RentalAgreementComponent,
    PrivacyPolicyComponent,
    LicenseAgreementComponent,
    RulesOfUseComponent,
    InsuranceComponent,
    KzLayoutComponent,
    BaseLayoutComponent,
    ByLayoutComponent,
    ByContactUsComponent,
    PartsComponent,
    PaymentInformationComponent,
    DocumentsComponent,
    DocumentCountriesComponent,
    MousemoveDirective,
    KgLayoutComponent,
    RequisitesComponent,
    RuLayoutComponent,
    RequisitesRuComponent,
    DrivingRulesComponent,
    HowToRideComponent,
    PublicOfferCourierComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
  ],
  providers: [],
  bootstrap: [AppComponent]
})

export class AppModule {

}
